import {
  INVALIDATE_STORIES,
  REQUEST_STORIES,
  RECEIVE_STORIES,
  RESET_ACTIVE_STORY,
  REQUEST_STORY,
  RECEIVE_STORY,
	RECEIVE_LIVE_STORY,
	REQUEST_LIVE_STORY,
  INVALIDATE_NEWS_SLIDES,
  REQUEST_NEWS_SLIDES,
  RECEIVE_NEWS_SLIDES,
  INVALIDATE_ZEDLINES,
  REQUEST_ZEDLINES,
  RECEIVE_ZEDLINES,
  REQUEST_AUTHOR,
  RECEIVE_AUTHOR
} from './actions'

export function zedlines(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_ZEDLINES:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case REQUEST_ZEDLINES:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case RECEIVE_ZEDLINES:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.zedlines,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}

export function newsSlides(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_NEWS_SLIDES:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case REQUEST_NEWS_SLIDES:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case RECEIVE_NEWS_SLIDES:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.slides,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}

export function stories(
  state = {
    pages: {},
    items: [],
    articles: {},
    authors: {}
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_STORIES:
      return Object.assign({}, state, {
        pages: {
          ...state.pages,
          [action.page]: {
            ...state.pages[action.page],
            didInvalidate: true
          }
        }
      })
    case REQUEST_STORIES:
      return Object.assign({}, state, {
        pages: {
          ...state.pages,
          [action.page]: {
            ...state.pages[action.page],
            isFetching: true,
            didInvalidate: false
          }
        }
      })
    case RECEIVE_STORIES:
      return Object.assign({}, state, {
        pages: {
          ...state.pages,
          [action.page]: {
            ...state.pages[action.page],
            isFetching: false,
            didInvalidate: false,
            lastUpdated: action.receivedAt
          }
        },
        items: state.items.concat(action.stories)
      })
    case REQUEST_STORY:
      return Object.assign({}, state, {
        articles: {
          ...state.articles,
          active: action.id,
          [action.id]: {
            ...state.articles[action.id],
            isFetching: true,
            didInvalidate: false
          }
        }
      })
    case RECEIVE_STORY:
      return Object.assign({}, state, {
        articles: {
          ...state.articles,
          [action.id]: {
            ...state.articles[action.id],
            isFetching: true,
            didInvalidate: false,
            ...action.story
          }
        }
      })
		case RECEIVE_LIVE_STORY:
			return Object.assign({}, state, {
				articles: {
					...state.articles,
					[action.id]: {
						...state.articles[action.id],
						isFetching: true,
						didInvalidate: false,
						live: [...action.story]
					}
				}
			})
    case RESET_ACTIVE_STORY:
      return Object.assign({}, state, {
        articles: {
          ...state.articles,
          active: null,
        }
      })
    case REQUEST_AUTHOR:
      return Object.assign({}, state, {
        authors: {
          ...state.authors,
          [action.id]: {
            ...state.authors[action.id],
            isFetching: true,
            didInvalidate: false
          }
        }
      })
    case RECEIVE_AUTHOR:
      return Object.assign({}, state, {
        authors: {
          ...state.authors,
          [action.id]: {
            ...state.authors[action.id],
            isFetching: true,
            didInvalidate: false,
            ...action.author
          }
        }
      })
    default:
      return state
  }
}
 
